import { render, staticRenderFns } from "./HerosEdit.vue?vue&type=template&id=9ed16112"
import script from "./HerosEdit.vue?vue&type=script&lang=js"
export * from "./HerosEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports